import React, { useEffect, useRef } from "react";
import { Box, Grid, CardMedia, Typography, Container } from "@mui/material";
import { useParams } from "react-router-dom";
import Colors from "assets/Style/Colors";
import { CommaSeparator } from "utils";
import {
  FontFamily,
  Images,
  InvoiceGlobal,
  InvoiceLocation,
  InvoiceMail,
  InvoicePhone,
} from "assets";
import { makeStyles } from "@mui/styles";
import moment from "moment";
import { QRCodeCanvas } from "qrcode.react";
import LogoImage from "assets/Images/header_voucher.svg";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

const useStyle = makeStyles({
  headingBg: {
    margin: "32px 0px",
    padding: "12px 0px",
    textAlign: "center",
  },
  heading: {
    color: Colors.white,
    textTransform: "uppercase",
    fontWeight: 300,
    fontFamily: FontFamily.openSans,
  },
  text: {
    color: Colors.smokeyGrey,
    fontWeight: 300,
    fontFamily: FontFamily.openSans,
  },
  tableCell: {
    backgroundColor: Colors.aliceBlue,
    border: "0.25px solid #D9D9D9",
    "& .MuiTypography-root": {
      padding: "4px 12px",
    },
  },
});

function FundTransferVoucherInvoice({ voucherDetail, onDone }) {
  const { id } = useParams();
  const contentRef = useRef(null);
  const classes = useStyle();

  useEffect(() => {
    if (!voucherDetail) return;

    setTimeout(async () => {
      const node = contentRef.current;
      if (!node) return;

      await document.fonts.ready;

      const canvas = await html2canvas(node, {
        scale: 2,
        useCORS: true,
        backgroundColor: "#fff",
      });

      const imgData = canvas.toDataURL("image/jpeg", 0.7);

      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "pt",
        format: [1000, 1030.32],
        compress: true,
      });

      pdf.addImage(imgData, "PNG", 0, 0, 1000, 1030.32);

      const blob = pdf.output("blob");
      const file = new File(
        [blob],
        `iftvVoucher-GWS-IFTV-${voucherDetail?.id}.pdf`,
        { type: "application/pdf" }
      );

      onDone?.(file);
    }, 600);
  }, [voucherDetail]);

  let newVehicle = voucherDetail?.new_voucher;

  const fromCurrencyLabel = String(
    voucherDetail?.from_currency || voucherDetail?.from_account?.currency || "",
  ).toUpperCase();
  const toCurrencyLabel = String(
    voucherDetail?.to_currency || voucherDetail?.to_account?.currency || "",
  ).toUpperCase();


  return (
    <Container>
      <div ref={contentRef}>
        <Box>
          <Box>
            {
               newVehicle === false ? (
                <>
                <Grid container justifyContent={"space-between"} spacing={0}>
              <Grid item xs={3.5} sm={3.5} md={3.5}>
                <Box
                  component={"img"}
                  src={LogoImage}
                  sx={{ width: "100%", alignItems: "center" }}
                />
              </Grid>
              <Grid item xs={8.5} sm={8.5} md={8.5}>
                <CardMedia image={Images.invoiceHeader} sx={{ mb: 2 }}>
                  <Typography
                    variant="h3"
                    sx={{ py: 3, textAlign: "center", color: Colors.white }}
                  >
                    Galaxy Used Cars Tr. LLC
                  </Typography>
                </CardMedia>
                {/* <Box sx={{backgroundColor:'green', borderLeft: '60px solid transparent'}}>
                <Typography
                    variant="h3"
                    sx={{ py: 3, textAlign: "center", color: Colors.white }}
                  >
                    Galaxy Used Cars Tr. LLC
                  </Typography>

                </Box> */}
                <Grid
                  container
                  spacing={1.5}
                  alignItems={"center"}
                  justifyContent={"space-evenly"}
                >
                  <Grid item xs={4} sm={4} md={4}>
                    <Box
                      sx={{
                        display: "flex",
                        gap: "5px",
                        alignItems: "center",
                      }}
                    >
                      <InvoicePhone />
                      <Typography
                        variant="body1"
                        sx={{
                          color: Colors.smokeyGrey,
                          fontFamily: FontFamily.openSans,
                        }}
                      >
                        +971 6 510 2000
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={6} sm={6} md={6}>
                    <Box
                      sx={{
                        display: "flex",
                        gap: "5px",
                        alignItems: "center",
                      }}
                    >
                      <InvoiceMail />
                      <Typography
                        variant="body1"
                        sx={{
                          color: Colors.smokeyGrey,
                          fontFamily: FontFamily.openSans,
                        }}
                      >
                        info@galaxyshipping.com
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={4} sm={4} md={4}>
                    <Box
                      sx={{
                        display: "flex",
                        gap: "5px",
                        alignItems: "center",
                      }}
                    >
                      <InvoiceGlobal />
                      <Typography
                        variant="body1"
                        sx={{
                          color: Colors.smokeyGrey,
                          fontFamily: FontFamily.openSans,
                        }}
                      >
                        https://galaxyshipping.com
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={6} sm={6} md={6}>
                    <Box
                      sx={{
                        display: "flex",
                        gap: "5px",
                        alignItems: "center",
                      }}
                    >
                      <InvoiceLocation />
                      <Typography
                        variant="body1"
                        sx={{
                          color: Colors.smokeyGrey,
                          fontFamily: FontFamily.openSans,
                        }}
                      >
                        Ind Area#4 P.O Box 83126, Sharjah , UAE
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Box
              sx={{
                my: 5,
                position: "relative",
                bgcolor: Colors.bluishCyan,
                width: 1,
                height: "12px",
              }}
            >
              <Typography
                component={"span"}
                variant="h2"
                sx={{
                  color: Colors.charcoalGrey,
                  bgcolor: Colors.white,
                  p: 2,
                  letterSpacing: "3px",
                  position: "absolute",
                  right: "90px",
                  top: "-40px",
                }}
              >
                FUND TRANSFER VOUCHER
              </Typography>
            </Box>
            <Grid
              container
              spacing={0}
              justifyContent={"space-between"}
              sx={{ mt: "65px" }}
            >
              <Grid item xs={5.5} sm={5.5} md={5.5}>
                <Box sx={{ ml: 4, mb: 5 }}>
                  <Grid container spacing={0.5}>
                    <Grid item xs={12} sm={12} md={12}>
                      <Typography
                        variant="h4"
                        className={classes.text}
                        sx={{ mb: 1 }}
                      >
                        Transfer From:
                      </Typography>
                    </Grid>
                    <Grid item xs={5} sm={5} md={5}>
                      <Typography variant="body1" className={classes.text}>
                        Account COA:
                      </Typography>
                    </Grid>
                    <Grid item xs={6} sm={6} md={6}>
                      <Typography
                        noWrap
                        variant="body1"
                        className={classes.text}
                      >
                        {voucherDetail?.from_account?.account_code ?? "-"}
                      </Typography>
                    </Grid>
                    <Grid item xs={5} sm={5} md={5}>
                      <Typography variant="body1" className={classes.text}>
                        Account Name:
                      </Typography>
                    </Grid>
                    <Grid item xs={6} sm={6} md={6}>
                      <Typography
                        noWrap
                        variant="body1"
                        className={classes.text}
                      >
                        {voucherDetail?.from_account?.name ?? "-"}
                      </Typography>
                    </Grid>
                    <Grid item xs={5} sm={5} md={5}>
                      <Typography variant="body1" className={classes.text}>
                        Currency:
                      </Typography>
                    </Grid>
                    <Grid item xs={6} sm={6} md={6}>
                      <Typography
                        noWrap
                        variant="body1"
                        className={classes.text}
                      >
                        {voucherDetail?.from_account?.currency?.toUpperCase() ??
                          "-"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} sx={{ mt: 3 }}>
                      <Typography
                        variant="h4"
                        className={classes.text}
                        sx={{ mb: 1 }}
                      >
                        Transfer To:
                      </Typography>
                    </Grid>
                    <Grid item xs={5} sm={5} md={5}>
                      <Typography variant="body1" className={classes.text}>
                        Account COA:
                      </Typography>
                    </Grid>
                    <Grid item xs={6} sm={6} md={6}>
                      <Typography
                        noWrap
                        variant="body1"
                        className={classes.text}
                      >
                        {voucherDetail?.to_account?.account_code ?? "-"}
                      </Typography>
                    </Grid>
                    <Grid item xs={5} sm={5} md={5}>
                      <Typography variant="body1" className={classes.text}>
                        Account Name:
                      </Typography>
                    </Grid>
                    <Grid item xs={6} sm={6} md={6}>
                      <Typography
                        noWrap
                        variant="body1"
                        className={classes.text}
                      >
                        {voucherDetail?.to_account?.name ?? "-"}
                      </Typography>
                    </Grid>
                    <Grid item xs={5} sm={5} md={5}>
                      <Typography variant="body1" className={classes.text}>
                        Currency:
                      </Typography>
                    </Grid>
                    <Grid item xs={6} sm={6} md={6}>
                      <Typography
                        noWrap
                        variant="body1"
                        className={classes.text}
                      >
                        {voucherDetail?.to_account?.currency?.toUpperCase() ??
                          "-"}
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>

                <Box
                  className={classes.headingBg}
                  sx={{ bgcolor: Colors.bluishCyan }}
                >
                  <Typography variant="h4" className={classes.heading}>
                    Notes
                  </Typography>
                </Box>
                <Box sx={{ ml: 4, mr: 2 }}>
                  <Typography variant="body1" className={classes.text}>
                    {voucherDetail?.notes}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={5.5} sm={5.5} md={5.5}>
                <Box sx={{ mr: 3, mt: 0 }}>
                  <Grid container spacing={0} justifyContent={"flex-end"}>
                    <Grid
                      item
                      xs={6}
                      sm={6}
                      md={6}
                      className={classes.tableCell}
                    >
                      <Typography variant="body1" className={classes.text}>
                        Voucher #:
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={6}
                      sm={6}
                      md={6}
                      className={classes.tableCell}
                    >
                      <Typography variant="body1" className={classes.text}>
                        GWS-IFTV-{voucherDetail?.id}
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={6}
                      sm={6}
                      md={6}
                      className={classes.tableCell}
                    >
                      <Typography variant="body1" className={classes.text}>
                        Branch:
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={6}
                      sm={6}
                      md={6}
                      className={classes.tableCell}
                    >
                      <Typography variant="body1" className={classes.text}>
                        {voucherDetail?.branch?.name ?? "-"}
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={6}
                      sm={6}
                      md={6}
                      className={classes.tableCell}
                    >
                      <Typography variant="body1" className={classes.text}>
                        Ref No #:
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={6}
                      sm={6}
                      md={6}
                      className={classes.tableCell}
                    >
                      <Typography variant="body1" className={classes.text}>
                        {voucherDetail?.ref_no}
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={6}
                      sm={6}
                      md={6}
                      className={classes.tableCell}
                    >
                      <Typography variant="body1" className={classes.text}>
                        Creation on:
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={6}
                      sm={6}
                      md={6}
                      className={classes.tableCell}
                    >
                      <Typography variant="body1" className={classes.text}>
                        {moment(voucherDetail?.createdAt).format("DD-MMM-YYYY")}
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={6}
                      sm={6}
                      md={6}
                      className={classes.tableCell}
                    >
                      <Typography variant="body1" className={classes.text}>
                        Customize Date:
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={6}
                      sm={6}
                      md={6}
                      className={classes.tableCell}
                    >
                      <Typography variant="body1" className={classes.text}>
                        {moment(voucherDetail?.c_date).format("DD-MMM-YYYY")}
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
                <Box
                  className={classes.headingBg}
                  sx={{ bgcolor: Colors.primary }}
                >
                  <Typography variant="h4" className={classes.heading}>
                    Amount Paid
                  </Typography>
                </Box>

                <Box sx={{ mr: 3, mb: 4 }}>
                  <Grid container spacing={0} justifyContent={"flex-end"}>
                    <Grid
                      item
                      xs={4}
                      sm={4}
                      md={4}
                      className={classes.tableCell}
                    >
                      <Typography
                        variant="body1"
                        className={classes.text}
                        sx={{
                          textAlign: "right",
                          fontWeight: "bold !important",
                        }}
                      >
                        {fromCurrencyLabel || "-"}
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={4}
                      sm={4}
                      md={4}
                      className={classes.tableCell}
                    >
                      <Typography
                        variant="body1"
                        className={classes.text}
                        sx={{
                          textAlign: "right",
                          fontWeight: "bold !important",
                        }}
                      >
                        Rate
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={4}
                      sm={4}
                      md={4}
                      className={classes.tableCell}
                    >
                      <Typography
                        variant="body1"
                        className={classes.text}
                        sx={{
                          textAlign: "right",
                          fontWeight: "bold !important",
                        }}
                      >
                        {toCurrencyLabel || "-"}
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={4}
                      sm={4}
                      md={4}
                      className={classes.tableCell}
                      sx={{ backgroundColor: "white !important" }}
                    >
                      <Typography
                        variant="body1"
                        className={classes.text}
                        sx={{ textAlign: "right" }}
                      >
                        {CommaSeparator(
                          parseFloat(voucherDetail?.from_amount)?.toFixed(2)
                        )}
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={4}
                      sm={4}
                      md={4}
                      className={classes.tableCell}
                      sx={{ backgroundColor: "white !important" }}
                    >
                      <Typography
                        variant="body1"
                        className={classes.text}
                        sx={{ textAlign: "right" }}
                      >
                        {parseFloat(voucherDetail?.exchange_rate)?.toFixed(3)}
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={4}
                      sm={4}
                      md={4}
                      className={classes.tableCell}
                      sx={{ backgroundColor: "white !important" }}
                    >
                      <Typography
                        variant="body1"
                        className={classes.text}
                        sx={{ textAlign: "right" }}
                      >
                        {CommaSeparator(
                          parseFloat(voucherDetail?.to_amount)?.toFixed(2)
                        )}
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
                <Box
                  className={classes.headingBg}
                  sx={{ pl: "32px !important", bgcolor: Colors.aliceBlue }}
                >
                  <Typography
                    variant="body1"
                    className={classes.heading}
                    sx={{
                      textAlign: "left",
                      color: `${Colors.charcoalGrey} !important`,
                    }}
                  >
                    <Typography
                      component={"span"}
                      variant="body2"
                      sx={{ textTransform: "none" }}
                    >
                      Created By: &nbsp; {voucherDetail?.creator?.name}
                    </Typography>
                  </Typography>
                </Box>
              </Grid>
            </Grid>
            <Grid container spacing={2} justifyContent={"space-between"}>
              <Grid item xs={12} sm={10}>
                <Box sx={{ pl: 4, pr: 3, mb: 3, mt: 4 }}>
                  <Typography variant="body1" sx={{ mb: 2 }}>
                    PLEASE READ CAREFULLY BELOW TERM & CONDITION:
                  </Typography>
                  <Typography
                    variant="body2"
                    className={classes.text}
                    sx={{ mb: 1 }}
                  >
                    1 - I've clearly informed and the make the understand all
                    the vehicle information, amount, charges and rates.
                  </Typography>
                  <Typography
                    variant="body2"
                    className={classes.text}
                    sx={{ mb: 1 }}
                  >
                    2 - Kindly pay the due amount within 3 business days from
                    the purchase date to avoid the Late Payment and Storages
                    that will be charged once vehicle arrived to final
                    destination (Further, If there are some special
                    annousment/memo ignore this and follow that)
                  </Typography>
                  <Typography
                    variant="body2"
                    className={classes.text}
                    sx={{ mb: 1 }}
                  >
                    3 - If vehicle got relisted, the relist charges customer has
                    to pay within 3 days otherwise 15% Penalty will applied
                    after 3 days as issued memo on 9/Jun/2022.
                  </Typography>
                  <Typography
                    variant="body2"
                    className={classes.text}
                    sx={{ mb: 1 }}
                  >
                    4 - Galaxy Customer care department will inform you about
                    the latest updates about rates and charges through WhatsApp
                    and emails.
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={2} sm={2}>
                <Box
                  sx={{
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <QRCodeCanvas
                    value={
                      window.location.origin +
                      `/fund-transfer-voucher-preview/${btoa("voucher-" + id)}`
                    }
                  />
                </Box>
              </Grid>
            </Grid>
            <Box sx={{ pl: 4, pr: 3, py: 1, bgcolor: Colors.primary }}>
              <Typography
                variant="caption"
                sx={{
                  color: Colors.white,
                  fontFamily: FontFamily.openSans,
                }}
              >
                Customer care Contact: Mohammed husni - +971523195682 (Arabic &
                English ) Ardamehr Shoev - +971545836028 (English ,Arabic, Tajik
                & Farsi)
              </Typography>
              <Typography
                variant="caption"
                sx={{
                  color: Colors.white,
                  fontFamily: FontFamily.openSans,
                }}
              >
                Ravin abdul kareem - +971528293801 (Kurdish , Arabic & English)
                Magsat Gylyjov - +97158666403 (Turken , Russian & English)
              </Typography>
            </Box>
                </>
               ):(
                <>
                <Grid container spacing={0}>
                <Box
                  sx={{
                    width: { xs: "100%", md: "25%" },
                    "@media print": {
                      width: "25%",
                      flex: "0 0 25%",
                    },
                    marginTop: "5px",
                  }}
                >
                  <Box
                    component="img"
                    src={LogoImage}
                    alt="Ship Logo"
                    sx={{
                      width: "100%",
                      objectFit: "contain",
                      display: "block",
                      maxHeight: "100px",
                    }}
                  />
                </Box>

                {/* Right Contact Info */}
                <Box
                  sx={{
                    backgroundColor: Colors.green,
                    padding: 2,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    width: { xs: "100%", md: "71.5%" },
                    marginRight: "3.5%",
                    "@media print": {
                      width: "71.5%",
                      flex: "0 0 71.5%",
                    },
                  }}
                >
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                      <Box
                        sx={{
                          display: "flex",
                          gap: 1,
                          alignItems: "center",
                        }}
                      >
                        <InvoicePhone />
                        <Typography
                          variant="body1"
                          sx={{
                            color: Colors.whiteSmoke,
                            fontFamily: FontFamily.openSans,
                            fontSize: 14,
                          }}
                        >
                          +971 6 510 2000
                        </Typography>
                      </Box>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <Box
                        sx={{
                          display: "flex",
                          gap: 1,
                          alignItems: "center",
                        }}
                      >
                        <InvoiceMail />
                        <Typography
                          variant="body1"
                          sx={{
                            color: Colors.whiteSmoke,
                            fontFamily: FontFamily.openSans,
                            fontSize: 14,
                          }}
                        >
                          info@galaxyshipping.com
                        </Typography>
                      </Box>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <Box
                        sx={{
                          display: "flex",
                          gap: 1,
                          alignItems: "center",
                        }}
                      >
                        <InvoiceGlobal />
                        <Typography
                          variant="body1"
                          sx={{
                            color: Colors.whiteSmoke,
                            fontFamily: FontFamily.openSans,
                            fontSize: 14,
                          }}
                        >
                          https://galaxyshipping.com
                        </Typography>
                      </Box>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <Box
                        sx={{
                          display: "flex",
                          gap: 1,
                          alignItems: "center",
                        }}
                      >
                        <InvoiceLocation />
                        <Typography
                          variant="body1"
                          sx={{
                            color: Colors.whiteSmoke,
                            fontFamily: FontFamily.openSans,
                            fontSize: 14,
                          }}
                        >
                          Ind Area#4 P.O Box 83126, Sharjah, UAE
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>

              <Box
                sx={{
                  my: 5,
                  position: "relative",
                  bgcolor: Colors.primary,
                  width: 1,
                  height: "12px",
                }}
              >
                <Typography
                  component={"span"}
                  variant="h2"
                  sx={{
                    color: Colors.charcoalGrey,
                    bgcolor: Colors.white,
                    p: 2,
                    letterSpacing: "3px",
                    position: "absolute",
                    right: "90px",
                    top: "-40px",
                  }}
                >
                  FUND TRANSFER VOUCHER
                </Typography>
              </Box>
              <Box sx={{ padding: 4 }}>

                <Grid container spacing={2} justifyContent="space-between">
                  {/* Left Side - Invoice To Section */}
                  <Grid item xs={12} sm={6}>

                    <Grid container spacing={0.5}>
                      <Grid item xs={12} sm={12} md={12}>
                         <Typography sx={{fontSize:'20px', fontWeight: 700, fontStyle:'Bold', fontFamily:'Helvetica'}}>Transfer From</Typography>
                      </Grid>
                     
                       <Grid item xs={12} sm={5}>
                        
                        <Typography sx={{fontSize:'16px', fontWeight: 400, fontStyle:'Regular', fontFamily:'Helvetica'}}>Account COA</Typography>
                        </Grid>
                      <Grid item xs={12} sm={7}>{voucherDetail?.from_account?.account_code ?? "-"}</Grid>
                       <Grid item xs={12} sm={5} > <Typography sx={{fontSize:'16px', fontWeight: 400, fontStyle:'Regular', fontFamily:'Helvetica'}}>Account Name</Typography></Grid>
                      <Grid item xs={12} sm={7}> {voucherDetail?.from_account?.name ?? "-"}</Grid>
                       <Grid item xs={12} sm={5} ><Typography sx={{fontSize:'16px', fontWeight: 400, fontStyle:'Regular', fontFamily:'Helvetica'}}>Currency</Typography></Grid>
                      <Grid item xs={12} sm={7}>{voucherDetail?.from_account?.currency?.toUpperCase() ?? "-"}</Grid>

                    </Grid>

                    
                    <Grid container spacing={0.5} mt={2}>
                      <Grid item xs={12} sm={12} md={12}>
                         <Typography  sx={{fontSize:'20px', fontWeight: 700, fontStyle:'Bold', fontFamily:'Helvetica'}}>Transfer To</Typography>
                      </Grid>
                      <Grid item xs={12} sm={5}>
                        
                        <Typography sx={{fontSize:'16px', fontWeight: 400, fontStyle:'Regular', fontFamily:'Helvetica'}}>Account COA</Typography>
                        </Grid>
                      <Grid item xs={12} sm={7}>{voucherDetail?.to_account?.account_code ?? "-"}</Grid>
                       <Grid item xs={12} sm={5} > <Typography sx={{fontSize:'16px', fontWeight: 400, fontStyle:'Regular', fontFamily:'Helvetica'}}>Account Name</Typography></Grid>
                      <Grid item xs={12} sm={7}>{voucherDetail?.to_account?.name ?? "-"}</Grid>
                       <Grid item xs={12} sm={5} ><Typography sx={{fontSize:'16px', fontWeight: 400, fontStyle:'Regular', fontFamily:'Helvetica'}}>Currency</Typography></Grid>
                      <Grid item xs={12} sm={7}>{voucherDetail?.to_account?.currency?.toUpperCase() ?? "-"}</Grid>

                    </Grid>


                    <Grid
                      container
                      sx={{ border: "1px solid #ddd", marginTop: "10px" }}
                    >
                      <Grid item xs={12}>
                        <Typography
                          variant="h6"
                          sx={{
                            fontFamily: "Helvetica",
                            textAlign: "center",
                            fontWeight: "bold",
                            padding: "8px",
                          }}
                        >
                          Amount Paid
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            width: "100%",
                          }}
                        >
                          <Box sx={{ overflowX: "auto", maxWidth: "100%" }}>
                            <table
                              style={{
                                width: "100%",
                                borderCollapse: "collapse",
                                margin: 0,
                                padding: 0,
                                tableLayout: "fixed",
                              }}
                            >
                              <thead>
                                <tr
                                  style={{
                                    background:
                                      "linear-gradient(90deg, #0C6135 0%, #5BBC0F 100%)",
                                    color: Colors.whiteSmoke,
                                    fontWeight: "bold",
                                  }}
                                >
                                  <th
                                    style={{
                                      padding: "8px",
                                      textAlign: "center",
                                      borderBottom: "2px solid #ddd",
                                      fontSize: "12px",
                                    }}
                                  >
                                   {fromCurrencyLabel || "-"}
                                  </th>
                                  <th
                                    style={{
                                      padding: "8px",
                                      textAlign: "center",
                                      borderBottom: "2px solid #ddd",
                                      fontSize: "12px",
                                    }}
                                  >
                                    Rate
                                  </th>
                                  <th
                                    style={{
                                      padding: "8px",
                                      textAlign: "center",
                                      borderBottom: "2px solid #ddd",
                                      fontSize: "12px",
                                    }}
                                  >
                                    {toCurrencyLabel || "-"}
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                    <tr>
                                      <td
                                        style={{
                                          padding: "8px",
                                          borderBottom: "1px solid #ddd",
                                          borderRight: "1px solid #ddd",
                                          borderLeft: "1px solid #ddd",
                                          fontSize: "12px",
                                          textAlign: "center",
                                        }}
                                      >
                                        {CommaSeparator(parseFloat(voucherDetail?.from_amount)?.toFixed(2))}
                                      </td>
                                      <td
                                        style={{
                                          padding: "8px",
                                          textAlign: "center",
                                          borderBottom: "1px solid #ddd",
                                          borderRight: "1px solid #ddd",
                                          fontSize: "12px",
                                        }}
                                      >
                                     {parseFloat(voucherDetail?.exchange_rate)?.toFixed(3)}

                                      </td>
                                      <td
                                        style={{
                                          padding: "8px",
                                          textAlign: "center",
                                          borderBottom: "1px solid #ddd",
                                          borderRight: "1px solid #ddd",
                                          fontSize: "12px",
                                        }}
                                      >
                                      {CommaSeparator(parseFloat(voucherDetail?.to_amount)?.toFixed(2))}
                                      </td>
                                    </tr>
                               
                              </tbody>
                            </table>
                          </Box>
                        </Box>
                      </Grid>
                    </Grid>

                    <Grid item xs={12} mt={3}>
                      <Typography
                        variant="body1"
                        sx={{
                          color: "black",
                          fontFamily: 'Helvetica',
                          fontWeight: "bold",
                          mb: "10px",
                          color: "#0C6135",
                        }}
                      >
                        PLEASE READ CAREFULLY THE TERMS & CONDITIONS:
                      </Typography>
                      <Box
                        sx={{
                          fontWeight: 500,
                          fontSize: "12px",
                        }}
                      >
                        <Typography
                          variant="body2"
                          sx={{
                            mb: 1,
                            fontFamily: 'Helvetica',
                          }}
                        >
                          1- I've clearly informed and the make the
                          understand all the vehicle information, amount,
                          charges and rates.
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{
                            mb: 1,
                            fontFamily: 'Helvetica',
                          }}
                        >
                          2- Kindly pay the due amount within 3 business
                          days from the purchase date to avoid the Late
                          Payment and Storages that will be charged once
                          vehicle arrived to final destination (Further, If
                          there are some special annousment/memo ignore this
                          and follow that).
                        </Typography>{" "}
                        <Typography
                          variant="body2"
                          sx={{
                            mb: 1,
                            fontFamily: 'Helvetica',
                          }}
                        >
                          3- If vehicle got relisted, the relist charges
                          customer has to pay within 3 days otherwise 15%
                          Penalty will applied after 3 days as issued memo
                          on 9/Jun/2022.
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{
                            mb: 1,
                            fontFamily: 'Helvetica',
                          }}
                        >
                          4- Galaxy Customer care department will inform you
                          about the latest updates about rates and charges
                          through WhatsApp and emails.
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>

                  {/* Right Side - Hello Text */}
                  <Grid item xs={12} sm={6}>
                    <Grid
                      container
                      // spacing={0.5}
                      sx={{ border: "1px solid #ddd", marginTop: "10px" }}
                    >
                      <Grid item xs={12}>
                        <Typography
                          variant="h6"
                          sx={{
                            fontFamily: "Helvetica",
                            textAlign: "center",
                            fontWeight: "bold",
                            padding: "8px",
                            background:
                              "linear-gradient(90deg, #0C6135 0%, #5BBC0F 100%)",
                            color: Colors.whiteSmoke,
                            fontWeight: "bold",
                          }}
                        >
                          Invoice Details
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sx={{ px: 2, py: 1.5 }}>
                        <Grid container sx={{ padding: "10px" }}>
                          
                          <Grid item xs={6}>
                            <Typography variant="body1">
                              Transaction type:
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography
                              variant="body1"
                              sx={{ fontFamily: FontFamily.NunitoRegular }}
                            >
                              { voucherDetail?.transaction_type ?? '-'}
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography variant="body1">
                              Voucher no:
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography
                              variant="body1"
                              sx={{ fontFamily: FontFamily.NunitoRegular }}
                            >
                               GWS-IFTV-{voucherDetail?.id}
                            </Typography>
                          </Grid>

                          <Grid item xs={6}>
                            <Typography variant="body1">
                              Branch:
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography
                              variant="body1"
                              sx={{ fontFamily: FontFamily.NunitoRegular }}
                            >
                              {voucherDetail?.branch?.name ?? "-"}
                            </Typography>
                          </Grid>

                          <Grid item xs={6}>
                            <Typography variant="body1">
                              Ref on:
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography
                              variant="body1"
                              sx={{ fontFamily: FontFamily.NunitoRegular }}
                            >
                              {voucherDetail?.ref_no ?? '-'}

                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography variant="body1">
                              Creation on:
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography
                              variant="body1"
                              sx={{ fontFamily: FontFamily.NunitoRegular }}
                            >
                             {moment(
                            voucherDetail?.createdAt
                          ).format("DD-MMM-YYYY")}
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography variant="body1">Customize Date:</Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography
                              variant="body1"
                              sx={{ fontFamily: FontFamily.NunitoRegular }}
                            >
                              {moment(voucherDetail?.c_date).format(
                            "DD-MMM-YYYY"
                          )}

                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography variant="body1">
                              Created by:
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography
                              variant="body1"
                              sx={{ fontFamily: FontFamily.NunitoRegular }}
                            >
                              {voucherDetail?.creator?.name}

                            </Typography>
                          </Grid>
                         
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid
                      container
                      sx={{ border: "1px solid #ddd", marginTop: "10px" }}
                    >
                      <Grid item xs={12} bgcolor="#F8F8F8">
                        <Typography
                          sx={{
                            fontFamily: "Helvetica",
                            fontWeight: 700,
                            padding: "10px",
                            fontSize: "18px",
                            color: "#0C6135",
                          }}
                        >
                          Notes
                        </Typography>
                      </Grid>
                      <Grid item xs={12} bgcolor="#F8F8F8">
                        <Typography
                          sx={{
                            fontFamily: "Helvetica",
                            fontWeight: 700,
                            padding: "10px",
                            fontSize: "14px",
                          }}
                        >
                          {voucherDetail?.notes ?? '-'}
                        </Typography>
                      </Grid>
                    </Grid>

                    <Typography
                      sx={{
                        fontFamily: "Helvetica",
                        fontWeight: 700,
                        padding: "10px",
                        fontSize: "16px",
                        color: "#FE2E1B",
                        marginTop: "12px",
                      }}
                    >
                      For complaints, Please whatsapp @ +4917663203237
                    </Typography>

                    <Grid item xs={12} mt={3}>
                      <Box
                        sx={{
                          height: "100%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "flex-end",
                        }}
                      >
                        <QRCodeCanvas
                      value={
                        window.location.origin +
                        `/fund-transfer-voucher-preview/${btoa(
                          "voucher-" + id
                        )}`
                      }
                    />

                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
              </Box>

              <Box
                sx={{ pl: 4, pr: 3, py: 1, bgcolor: Colors.primary, mt: 4 }}
              >
                <Typography
                  variant="caption"
                  sx={{
                    color: Colors.white,
                    fontFamily: FontFamily.openSans,
                  }}
                >
                  Customer care Contact: Mohammed husni - +971523195682
                  (Arabic & English ) Ardamehr Shoev - +971545836028
                  (English ,Arabic, Tajik & Farsi)
                </Typography>
                <Typography
                  variant="caption"
                  sx={{
                    color: Colors.white,
                    fontFamily: FontFamily.openSans,
                  }}
                >
                  Ravin abdul kareem - +971528293801 (Kurdish , Arabic &
                  English) Magsat Gylyjov - +97158666403 (Turken , Russian &
                  English)
                </Typography>
                <Typography
                  variant="caption"
                  sx={{
                    color: Colors.white,
                    fontFamily: FontFamily.openSans,
                  }}
                >
                  Ind Area#4 P.O Box 83126, Sharjah, UAE.
                </Typography>
              </Box>
                
                </>
               )
            }
            
          </Box>
        </Box>
      </div>
    </Container>
  );
}

export default FundTransferVoucherInvoice;
